// src/mocks/handlers/dashboard/currencyExposure.ts

import { rest } from 'msw';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_MSW_BASE_URL } from '@/config';
import { ICurrencyExposureResponse } from '@/domains/dashboard/currencyExposure/currencyExposure.type';
import currencyExposureData from '@/mocks/data/dashboard_currencyExposure.json';
import { isAccessTokenExpired } from '@/mocks/lib/authTokenUtils';
import { format, subDays } from 'date-fns';

export const currencyExposureHandler = rest.get<
  ICurrencyExposureResponse,
  { customer_uuid: string }
>(
  `${VITE_MSW_BASE_URL}${API_ENDPOINTS.DASHBOARD_CURRENCY_EXPOSURE}`,
  (req, res, ctx) => {
    const { customer_uuid } = req.params;

    if (isAccessTokenExpired()) {
      return res(ctx.status(401), ctx.json({ error: 'Access token expired' }));
    }

    // Filter the data based on the customer_uuid
    const customerData = currencyExposureData.find(
      (entry) => entry.uuid === customer_uuid,
    );

    if (!customerData) {
      return res(ctx.status(404), ctx.json({ error: 'Customer not found' }));
    }

    const today = new Date();
    const updated_at = `${format(subDays(today, 5), 'yyyy-MM-dd')}`;

    const response: ICurrencyExposureResponse = {
      aggregated_exposure: customerData.aggregated_exposure,
      breakdown: customerData.breakdown,
      updated_at: customerData.updated_at || updated_at,
    };

    return res(ctx.status(200), ctx.json(response));
  },
);
